const UPDATE_GALLERIE_COUNTER_TYPE = "UPDATE_GALLERIE_COUNTER"
const INCREMENT_GALLERIE_COUNTER_TYPE = "INCREMENT_GALLERIE_COUNTER"
const DECREMENT_GALLERIE_COUNTER_TYPE = "DECREMENT_GALLERIE_COUNTER"
const REMOVE_SWIPE_TYPE = "REMOVE_SWIPE"
const INCREMENT_SKILL_COUNTER_TYPE = "INCREMENT_SKILL_COUNTER"
const DECREMENT_SKILL_COUNTER_TYPE = "DECREMENT_SKILL_COUNTER"
const TRIGGER_GALLERIE_VIEWER_TYPE = "TRIGGER_GALLERIE_VIEWER"
const HIDE_GALLERIE_VIWER_TYPE = "HIDE_GALLERIE_VIWER"



export const updateGallerieCounter = payload => ({
	type: UPDATE_GALLERIE_COUNTER_TYPE,
	payload
})

export const incrementGallerieCounter = payload => ({
	type: INCREMENT_GALLERIE_COUNTER_TYPE,
	payload	
})

export const decrementGallerieCounter = payload => ({
	type: DECREMENT_GALLERIE_COUNTER_TYPE,
	payload	
})

export const removeSwipe = () => ({
	type: REMOVE_SWIPE_TYPE
})

export const incrementSkillCounter = payload => ({
	type: INCREMENT_SKILL_COUNTER_TYPE,
	payload
})

export const decrementSkillCounter = payload => ({
	type: DECREMENT_SKILL_COUNTER_TYPE,
	payload
})

export const triggerGallerieViewer = payload => ({
	type: TRIGGER_GALLERIE_VIEWER_TYPE,
	payload
})

export const hideGallerieViewer = () => ({
	type: HIDE_GALLERIE_VIWER_TYPE
})